import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContratosRoutingModule } from './contratos-routing.module';
import { ContratoDetalhesComponent } from './contrato-detalhes/contrato-detalhes.component';
import { ContratoBeneficiarioComponent } from './contrato-beneficiario/contrato-beneficiario.component';
import { ContratoFinanciamentoComponent } from './contrato-financiamento/contrato-financiamento.component';
import { CoreModule } from 'src/app/core/core.module';
import { ContratosComponent } from './contratos.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContratoBeneficiarioFormComponent } from './contrato-beneficiario-form/contrato-beneficiario-form.component';
import { ContratoLogComponent } from './contrato-log/contrato-log.component';
import { ContratoEditarComissaoComponent } from './contrato-editar-comissao/contrato-editar-comissao.component';
import { NgxMaskPipe } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { ContratoEditarValorCredimorarComponent } from './contrato-editar-valor-credimorar/contrato-editar-valor-credimorar.component';

@NgModule({
  declarations: [
    ContratoBeneficiarioComponent,
    ContratoDetalhesComponent,
    ContratoFinanciamentoComponent,
    ContratosComponent,
    ContratoBeneficiarioFormComponent,
    ContratoLogComponent,
    ContratoEditarComissaoComponent,
    ContratoEditarValorCredimorarComponent
  ],
  imports: [
    CommonModule,
    ContratosRoutingModule,
    CoreModule,
    SharedModule,
    NgxMaskPipe,
    ReactiveFormsModule],
  exports: [
    ContratoBeneficiarioFormComponent,
  ]
})
export class ContratosModule { }
